import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { navLinks } from '../mock';

const Logo = ({ className = '' }) => (
  <span className={`brand text-2xl inline-flex items-center ${className}`}>
    flix<span className="text-[#0e9f6e]">.</span>
  </span>
);

const Navbar = ({ onDownload }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 px-4 pt-4">
      <nav
        className={`mx-auto max-w-6xl flex items-center justify-between rounded-2xl px-5 py-3 transition-all duration-300 ${
          scrolled ? 'bg-white/90 backdrop-blur-md shadow-[0_8px_30px_rgba(15,23,18,0.08)]' : 'bg-white/60 backdrop-blur-sm'
        }`}
      >
        <Link to="/" className="text-[#0f1712] pr-2"><Logo /></Link>

        <div className="hidden lg:flex items-center gap-7">
          {navLinks.map((l) => (
            <Link key={l.label} to={l.to} className="text-sm font-medium text-[#0f1712]/70 hover:text-[#0f1712] transition-colors">
              {l.label}
            </Link>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/app" className="text-sm font-semibold text-[#0f1712] hover:text-[#0e9f6e] transition-colors">Open app</Link>
          <button onClick={onDownload} className="bg-[#0e9f6e] text-white rounded-xl px-5 py-2.5 text-sm font-semibold hover:bg-[#0c8a60] transition-colors">
            Get FLIX free
          </button>
        </div>

        <button className="lg:hidden text-[#0f1712]" onClick={() => setOpen(!open)} aria-label="menu">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden mx-auto max-w-6xl mt-2 rounded-2xl bg-white p-6 flex flex-col gap-4 shadow-xl">
          {navLinks.map((l) => (
            <Link key={l.label} to={l.to} className="text-sm font-medium text-[#0f1712]/80 hover:text-[#0e9f6e]">{l.label}</Link>
          ))}
          <Link to="/app" className="text-sm font-medium text-[#0f1712]/80 hover:text-[#0e9f6e]">Open app</Link>
          <button onClick={onDownload} className="mt-2 bg-[#0e9f6e] text-white rounded-xl px-5 py-3 text-sm font-semibold">Get FLIX free</button>
        </div>
      )}
    </header>
  );
};

export { Logo };
export default Navbar;
